import {OnestSemiBoldMed} from "../styled/TextComponents";

export const BlockTitle = ({title}) => {
    return (
        <div style={{
            width: "100%",
            marginBottom: 20,
        }}>
            <OnestSemiBoldMed style={{fontSize: 24}}>{title}</OnestSemiBoldMed>
        </div>
    )
}